/* ============================================================
   CANDELINAS CUSTOM: paid-media landing pages (lp-* sections)
   - add to cart via /cart/add.js, then open the native quick-cart
   - sticky bar (always visible)
   - quantity ladder (lp-ladder) that drives the form quantity
   - secondary buttons that submit the primary form
   ============================================================ */
(function () {
  'use strict';
  if (window.__cdlLpInit) return;
  window.__cdlLpInit = true;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + v.replace(/,00$/, '');
  }

  function primaryForm() {
    return document.querySelector('[data-lp-form]');
  }

  function openQuickCart() {
    var hasDrawer = document.querySelector('.quick-cart');
    document.dispatchEvent(new CustomEvent('quick-cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    if (!hasDrawer) { window.location.href = '/cart'; return; }
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('quick-cart:open', { bubbles: true }));
    }, 350);
  }

  function setLoading(btns, on) {
    btns.forEach(function (b) {
      if (on) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
      else { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }
    });
  }

  function addToCart(form) {
    var id = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!id) return Promise.reject(new Error('no variant'));
    var fd = new FormData();
    fd.append('id', id.value);
    fd.append('quantity', qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1);
    fd.append('form_type', 'product');
    fd.append('utf8', '✓');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (item) {
      if (!item || !item.id) throw new Error((item && item.description) || 'add failed');
      return item;
    });
  }

  function flashAdded(btns) {
    btns.forEach(function (b) {
      var label = b.querySelector('[data-lp-label]') || b;
      var original = label.innerHTML;
      var added = b.getAttribute('data-lp-added-label') || 'ΠΡΟΣΤΕΘΗΚΕ';
      label.textContent = added;
      b.classList.add('is-added');
      setTimeout(function () {
        label.innerHTML = original;
        b.classList.remove('is-added');
        // repaint ladder-driven spans that were just restored
        var on = document.querySelector('[data-lp-tier].is-on');
        if (on) on.click();
      }, 2200);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-lp-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-on', cart.item_count > 0);
      });
    }).catch(function () {});
  }

  function submitPrimary(triggerBtn) {
    var form = primaryForm();
    if (!form) return;
    var btns = [form.querySelector('[data-lp-add]'), triggerBtn].filter(Boolean);
    setLoading(btns, true);
    addToCart(form).then(function () {
      setLoading(btns, false);
      flashAdded(btns);
      refreshCartCount();
      openQuickCart();
    }).catch(function () {
      setLoading(btns, false);
      // last resort: native submit to /cart/add (full page)
      try { form.submit(); } catch (e) { window.location.href = '/cart'; }
    });
  }

  /* ---- ladder: tiers set the quantity + repaint totals ---- */
  function initLadder() {
    var ladder = document.querySelector('[data-lp-ladder]');
    if (!ladder) return;
    var unit = parseInt(ladder.getAttribute('data-unit-price'), 10) || 0;      // cents
    var value = parseInt(ladder.getAttribute('data-unit-value'), 10) || 0;     // cents (sum of components)
    var freeAt = parseInt(ladder.getAttribute('data-free-shipping'), 10) || 0; // cents
    var tiers = Array.prototype.slice.call(ladder.querySelectorAll('[data-lp-tier]'));

    function apply(tier) {
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var total = unit * qty;
      var totalValue = value * qty;
      tiers.forEach(function (t) { t.classList.toggle('is-on', t === tier); t.setAttribute('aria-pressed', t === tier ? 'true' : 'false'); });
      var form = primaryForm();
      if (form) { var q = form.querySelector('[name="quantity"]'); if (q) q.value = qty; }
      document.querySelectorAll('[data-lp-total]').forEach(function (el) { el.textContent = money(total); });
      document.querySelectorAll('[data-lp-qty-label]').forEach(function (el) { el.textContent = tier.getAttribute('data-label') || ''; });
      document.querySelectorAll('[data-lp-value]').forEach(function (el) { el.textContent = money(totalValue); });
      document.querySelectorAll('[data-lp-save]').forEach(function (el) { el.textContent = money(Math.max(0, totalValue - total)); });
      document.querySelectorAll('[data-lp-ship]').forEach(function (el) {
        if (!freeAt) return;
        el.textContent = total >= freeAt ? (el.getAttribute('data-free-text') || 'ΔΩΡΕΑΝ ΜΕΤΑΦΟΡΙΚΑ') : (el.getAttribute('data-paid-text') || '');
      });
      var ev = new CustomEvent('lp:tier', { detail: { qty: qty, total: total } });
      document.dispatchEvent(ev);
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { apply(t); });
    });
    var initial = tiers.filter(function (t) { return t.classList.contains('is-on'); })[0] || tiers[0];
    if (initial) apply(initial);
  }

  /* ---- sticky bar: always visible (Panos, 2026-09-16) ---- */
  function initSticky() {
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;
    bar.classList.add('is-on');
    document.body.classList.add('lp-sticky-on');
    liftAbovePreviewBar();
  }

  /* ---- preview links only (?preview_theme_id=…): Shopify injects its own bottom "preview bar" iframe
     that would cover the sticky bar. Measure its clickable height and lift the sticky bar above it.
     On the live theme the iframe does not exist, so this is a no-op. ---- */
  var liftBound = false;
  function liftAbovePreviewBar() {
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;
    var pbar = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
    var lift = 0;
    if (pbar && pbar.getBoundingClientRect().height > 0) {
      var x = Math.round(window.innerWidth / 2);
      for (var y = 1; y <= 160; y += 2) {
        var el = document.elementFromPoint(x, window.innerHeight - y);
        if (el !== pbar) { lift = y > 1 ? y : 0; break; }
      }
    }
    bar.style.bottom = lift ? lift + 'px' : '';
    document.body.style.paddingBottom = lift ? (70 + lift) + 'px' : '';
    if (!liftBound) {
      liftBound = true;
      [400, 1200, 3000].forEach(function (ms) { setTimeout(liftAbovePreviewBar, ms); });
      window.addEventListener('resize', function () { liftAbovePreviewBar(); });
    }
  }

  /* ---- desktop: the quantity ladder moves into the hero body, under the title ---- */
  var ladderHome = null;
  function placeLadder() {
    var ladderSection = document.querySelector('.lp[data-section-type="lp-ladder"]');
    var heroBody = document.querySelector('.lp-hero__body');
    if (!ladderSection || !heroBody) return;
    var inner = ladderSection.querySelector('.lp-ladder-inner') || ladderSection.querySelector('.lp-wrap');
    if (!inner) return;
    var desktop = window.matchMedia('(min-width: 900px)').matches;
    if (desktop && inner.parentNode !== heroBody) {
      if (!ladderHome) { ladderHome = document.createComment('lp-ladder-home'); inner.parentNode.insertBefore(ladderHome, inner); }
      inner.classList.add('lp-ladder--in-hero');
      heroBody.appendChild(inner);
      ladderSection.classList.add('lp-ladder--moved');
    } else if (!desktop && inner.parentNode === heroBody && ladderHome && ladderHome.parentNode) {
      inner.classList.remove('lp-ladder--in-hero');
      ladderHome.parentNode.insertBefore(inner, ladderHome);
      ladderSection.classList.remove('lp-ladder--moved');
    }
  }

  /* ---- wiring ---- */
  function init() {
    var form = primaryForm();
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitPrimary(null);
      });
    }
    document.querySelectorAll('[data-lp-add-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        submitPrimary(btn);
      });
    });
    document.querySelectorAll('[data-lp-open-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (document.querySelector('.quick-cart')) {
          document.dispatchEvent(new CustomEvent('quick-cart:open', { bubbles: true }));
        } else { window.location.href = '/cart'; }
      });
    });
    document.querySelectorAll('[data-lp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
    placeLadder();
    initLadder();
    initSticky();
    refreshCartCount();
    window.addEventListener('resize', function () { placeLadder(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme editor: re-init when a section is re-rendered
  document.addEventListener('shopify:section:load', function () { placeLadder(); initLadder(); initSticky(); });
})();
